export default __webpack_public_path__ + "static/media/about-us-3.abb0db15.svg";